'use client'

import { useRef } from 'react'
import {
  motion,
  useScroll,
  useSpring,
  useTransform,
} from 'framer-motion'

/**
 * Vertical parallax similar to legacy basicScroll on #product-shot (0 → 400px).
 */
export const ParallaxProductShot = ({
  src,
  alt,
  className,
  marginBottom,
}: {
  src: string
  alt: string
  className?: string
  /** e.g. mb-[400px] for Hocus Pocus */
  marginBottom?: string
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  })
  const y = useSpring(useTransform(scrollYProgress, [0, 1], [0, 400]), {
    stiffness: 100,
    damping: 30,
  })

  return (
    <div ref={ref} className={`hidden md:block ${marginBottom ?? ''}`}>
      <motion.img
        src={src}
        alt={alt}
        className={className ?? 'w-3/4'}
        style={{ y }}
      />
    </div>
  )
}
